{
	"add-picture": "Bæta við mynd",
	"add-picture-info-text": "Mynd af sendingunni og innri og ytri umbúðum svo hægt sé að meta tjón.",
	"add-receipt": "Bæta við reikningi",
	"add-receipt-info-text": "Afrit af vörureikningi svo hægt sé að meta skaðabætur. Ef sending er frá útlöndum þá afrit/mynd af fylgibréfi.",
	"bankInfo": "Bankaupplýsingar",
	"content": "Innihald",
	"description-of-damage": "Lýsing á tjóni",
	"description-of-damage-placeholder": "Lýstu tjóninu eins vel og hægt er ...",
	"email-copy-of-report": "Netfang fyrir afrit skýrslu",
	"error-heading": "Villa kom upp!",
	"form-response": {
		"back-button": "Skrá aftur",
		"back-button-path": "/posturinn/umsoknir/tilkynna-tjon/",
		"error": "Villa",
		"text-error": "Upp kom villa. Vinsamlegast reynið aftur síðar.",
		"text-success": "Aðgerð tókst. Tjónatilkynning hefur verið móttekin. Afrit af tjónaskýrslunni sendist á",
		"thank-you": "Takk fyrir"
	},
	"handle-damaged-items": {
		"item-missing": "Vöntun í sendingu",
		"receiver-keeps-item": "Viðtakandi ætlar að halda vörunni",
		"receiver-keeps-item-info": "Greiddar 30-35% skaðabætur af andvirði vöru",
		"sender-keeps-item": "Sendandi ætlar að halda vöru",
		"sender-keeps-item-info": "Greiddar 30-35% skaðabætur af andvirði vöru",
		"send-item-to-claims-department": "Vara send til tjónadeildar",
		"send-item-to-claims-department-info": "Ath. Ekki er gengið frá skaðabótum fyrr en sending hefur borist Tjónadeild",
		"sender-received-item": "Vara komin til sendanda",
		"shipment-lost": "Sending talin glötuð"
	},
	"how-to-handle": "Ósk tjónaþola um meðhöndlun tjónavöru",
	"info-about-damage": "Upplýsingar um tjón",
	"info-about-sender": "Upplýsingar um sendanda",
	"infoSenderReceiver": "Upplýsingar um sendanda og viðtakanda",
	"item-missing": "Vöntun í sendingu",
	"item-missing-text": "Á við um sendingar þar sem vantar hluta úr.",
	"onlyIceland": "Vinsamlegast athugið: Ef sending verður fyrir tjóni annars staðar en á Íslandi þarf að tilkynna tjónið í því landi sem það átti sér stað í.",
	"payer-has-foreign-bankaccount": "Erlendur bankareikningur",
	"receiver-foreign-address": "Viðtakandi er með erlent ríkisfang",
	"report": "Tilkynna",
	"report-damage": "Tilkynna tjón",
	"report-damage-text": "Á við um sendingar sem hafa orðið fyrir tjóni.",
	"sender-foreign-address": "Sendandi er ekki með íslenska kennitölu",
	"sendReport": "Senda in tilkynningu",
	"shipment-missing": "Glötuð sending",
	"shipment-missing-text": "Á við um sendingar sem teljast glataðar. Gengið verður frá tjónamáli 3-6 mánuðum eftir skráningu.",
	"steps": {
		"step1": "Um tjón",
		"step2": "Upplýsingar",
		"step3": "Bankaupplýsingar",
		"step4": "Kvittun"
	},
	"who-completes-report": "Hver fyllir út skýrsluna?",
	"who-completes-report-options": {
		"employee": "Starfsmaður Póstsins",
		"other": "Annar",
		"receiver": "Viðtakandi",
		"sender": "Sendandi"
	},
	"info-text": {
		"1": "Hámarks skaðabætur fyrir böggul eru 22.500 kr.",
		"2": "Kvittanir/reikningar fyrir innihaldi sendingar þurfa að fylgja með þegar tjón er tilkynnt.",
		"3": "Gengið verður frá skaðabótum þegar öll nauðsynleg gögn hafa verið móttekin.",
		"4": "Eftirfarandi er ekki skaðabótaskylt: peningar, verðskjöl, skartgripir, málverk og matvæli."
	}
}
